// extracted by mini-css-extract-plugin
export default {"table-title":"eGyHUceQw7FGpMqr3ODP","title-icon":"WCZX924khH41si7REhE3"};